import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Offcanvas } from "react-bootstrap";
import { useAuth } from "../context/AuthContext";
import { useLeague } from "../hooks/useLeague";
import MobileUserProfile from "../Common/MobileUserProfile";
import "./Marketing.css";

export default function MarketingNavbar() {
  const auth = useAuth();
  const { currentLeague } = useLeague();
  const isAuthenticated = auth.isAuthenticated();
  const [showMenu, setShowMenu] = useState(false);

  const handleClose = () => setShowMenu(false);
  const handleShow = () => setShowMenu(true);

  // Close menu on navigation
  const handleLinkClick = () => {
    setShowMenu(false);
  };

  return (
    <header className="mk-header">
      <div className="mk-header-container">
        <Link to="/" className="mk-brand">
          <span className="mk-brand-mark" aria-hidden="true">
            <i className="bi bi-bar-chart-steps" />
          </span>
          <span className="mk-brand-name">Podium</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="mk-nav-desktop">
          {isAuthenticated ? (
            <>
              <Link to="/leagues" className="mk-btn-ghost">
                My Leagues
              </Link>
              <Link to="/setup/league" className="mk-btn-solid">
                Create League
              </Link>
            </>
          ) : (
            <>
              <Link to="/login" className="mk-btn-ghost">
                Log in
              </Link>
              {currentLeague && (
                <Link
                  to={`/leagues/${currentLeague.abbr}`}
                  className="mk-btn-ghost"
                >
                  {currentLeague.name}
                </Link>
              )}
              <Link to="/setup/league" className="mk-btn-solid">
                Create League
              </Link>
            </>
          )}
        </nav>

        {/* Mobile Hamburger Button */}
        <button
          className="mk-hamburger d-md-none"
          onClick={handleShow}
          aria-label="Open menu"
        >
          <i className="bi bi-list" />
        </button>

        {/* Mobile Offcanvas Menu */}
        <Offcanvas
          show={showMenu}
          onHide={handleClose}
          placement="end"
          className="mk-offcanvas"
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title>
              <div className="mk-brand">
                <span className="mk-brand-mark" aria-hidden="true">
                  <i className="bi bi-bar-chart-steps" />
                </span>
                <span className="mk-brand-name">Podium</span>
              </div>
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <nav className="mk-nav-mobile">
              {isAuthenticated ? (
                <>
                  <Link
                    to="/leagues"
                    className="mk-nav-mobile-link"
                    onClick={handleLinkClick}
                  >
                    <i className="bi bi-trophy me-2" />
                    My Leagues
                  </Link>
                  <Link
                    to="/setup/league"
                    className="mk-nav-mobile-link mk-nav-mobile-link-primary"
                    onClick={handleLinkClick}
                  >
                    <i className="bi bi-plus-circle me-2" />
                    Create League
                  </Link>
                </>
              ) : (
                <>
                  <Link
                    to="/login"
                    className="mk-nav-mobile-link"
                    onClick={handleLinkClick}
                  >
                    <i className="bi bi-box-arrow-in-right me-2" />
                    Log in
                  </Link>
                  {currentLeague && (
                    <Link
                      to={`/leagues/${currentLeague.abbr}`}
                      className="mk-nav-mobile-link"
                      onClick={handleLinkClick}
                    >
                      <i className="bi bi-trophy me-2" />
                      {currentLeague.name}
                    </Link>
                  )}
                  <Link
                    to="/setup/league"
                    className="mk-nav-mobile-link mk-nav-mobile-link-primary"
                    onClick={handleLinkClick}
                  >
                    <i className="bi bi-plus-circle me-2" />
                    Create League
                  </Link>
                </>
              )}
              <MobileUserProfile onLinkClick={handleLinkClick} />
            </nav>
          </Offcanvas.Body>
        </Offcanvas>
      </div>
    </header>
  );
}
